"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var AppEnums_1 = require("../../../../shared/constants/AppEnums");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a, _b;
    return {
        navItem: {
            height: 40,
            marginTop: 2,
            marginBottom: 2,
            width: 'calc(100% - 16px)',
            borderRadius: '0 30px 30px 0',
            paddingLeft: theme.direction === 'ltr'
                ? function (props) {
                    return 24 + 40 * props.level;
                }
                : 24,
            paddingRight: theme.direction === 'rtl'
                ? function (props) {
                    return 24 + 40 * props.level;
                }
                : 24,
            '& .nav-item-text': (_a = {
                    fontWeight: AppEnums_1.Fonts.REGULAR,
                    // fontSize: 16,
                    color: theme.palette.sidebar.textColor
                },
                _a[theme.breakpoints.up('xl')] = {
                    marginTop: 4,
                    marginBottom: 4,
                    // fontSize: 18,
                },
                _a),
            '& .nav-item-icon': {
                color: theme.palette.sidebar.textColor,
            },
            '& .nav-item-icon-arrow': {
                color: theme.palette.sidebar.textColor,
            },
            '& .MuiIconButton-root': {
                marginRight: -16,
            },
            '&.open, &:hover, &:focus': {
                '& .nav-item-text': {
                    fontWeight: AppEnums_1.Fonts.MEDIUM,
                    color: function (props) {
                        return props.themeMode === AppEnums_1.ThemeMode.LIGHT ? theme.palette.primary.main : '#fff';
                    },
                },
                '& .nav-item-icon': {
                    color: function (props) {
                        return props.themeMode === AppEnums_1.ThemeMode.LIGHT ? theme.palette.primary.main : '#fff';
                    },
                },
                '& .nav-item-icon-arrow': {
                    color: function (props) {
                        return props.themeMode === AppEnums_1.ThemeMode.LIGHT ? theme.palette.primary.main : '#fff';
                    },
                },
            },
        },
        listItemText: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        listIcon: (_b = {
                fontSize: 18
            },
            _b[theme.breakpoints.up('xl')] = {
            // fontSize: 20,
            },
            _b),
        imageIcon: {
            display: 'flex',
            height: 'inherit',
            width: 'inherit'
        },
        iconRoot: {
            textAlign: 'center'
        }
    };
});
exports.default = useStyles;
//# sourceMappingURL=VerticalCollapase.style.js.map